import cn from '@integrations/classnames'
import { configuration } from 'mmfintech-backend-api'
import { getCountryImageUrl } from 'mmfintech-commons'
import styles from './CurrencyIcon.module.scss'

interface Props {
  country: string
  size?: string
  circle?: boolean
  className?: string
}

function CountryIcon({ country, size, circle, className }: Props) {
  return (
    <div
      className={cn(
        styles['currency-icon-wrapper'],
        'currency-icon-wrapper',
        'country-icon',
        { [styles['circle']]: circle, circle },
        className
      )}
      {...(size ? { style: { width: size, height: size } } : {})}
    >
      <img src={`${configuration.getBaseUrl()}${getCountryImageUrl(country)}`} alt='' />
    </div>
  )
}

export default CountryIcon
